module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "hero is-primary"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('contact.title')))])])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [(!_vm.formSubmitted) ? _c('form', {
    staticClass: "form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateForm()
      }
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input is-primary is-medium",
    class: {
      'is-danger': _vm.errors.has('name')
    },
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": _vm.$t('common.name')
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email|required'),
      expression: "'email|required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input is-primary is-medium",
    class: {
      'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": _vm.$t('common.email')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    staticClass: "input is-primary is-medium",
    class: {
      'is-danger': _vm.errors.has('subject')
    },
    attrs: {
      "type": "text",
      "name": "subject",
      "placeholder": _vm.$t('common.subject')
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subject')),
      expression: "errors.has('subject')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('subject')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "textarea is-primary is-medium",
    class: {
      'is-danger': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "placeholder": _vm.$t('common.message')
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('message')),
      expression: "errors.has('message')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('message')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-fullwidth",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.send')) + "\n            ")])])])])]) : _c('div', [(!_vm.sendEmailError) ? _c('div', {
    staticClass: "message is-primary"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('contact.success')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.sendEmailError) ? _c('div', {
    staticClass: "message is-danger"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('contact.error')) + "\n        ")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2694b19c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contact.vue
// module id = 110
// module chunks = 0